// extracted by mini-css-extract-plugin
export default {"content":"GenerationSection_content__Q5KxK"};